import React, { Component } from "react";
import { Button, Glyphicon } from "react-bootstrap";
import "../css/StopWatch.css";

export default class StopWatch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            elapsed: 0,
            active_state: "START",
            display: this.props.displayStopwatch
        };
    }

    componentWillUnmount(){
        //clearInterval(this.timer);
    }

    startTimer = () =>{
        var start = Date.now();
        this.timer = setInterval(() => {this.tick(start)}, 50);
    }

    handleCounter = () => {
        this.runTimer();
    }

    tick = (start_time) => {
        this.setState({elapsed: new Date() - start_time});
    }

    handleStopCounter = event => {
        event.preventDefault();
        this.setState({
            elapsed: 0,
            active_state: "START"
        })
    }

    runTimer = () => {
        var active;
        if(this.state.active_state === "START") {
            active = "PAUSE";

            this.startTimer();
        }
        else if(this.state.active_state === "PAUSE")
        {
            active = "RESUME";
            this.setState({ rem_secs: this.state.elapsed }) ;//new Date() - this.state.elapsed })
            clearInterval(this.timer); // Pause TIMER
        }
        else if(this.state.active_state === "RESUME")
        {
            active = "PAUSE";
            var resume = new Date() - this.state.rem_secs;
            this.timer = setInterval(() => {this.tick(resume)}, 50);
        } else if(this.state.active_state === "STOP") {
            clearInterval(this.timer);
            active = "START";
        } else {
            active = "START";
        }

        this.setState({ active_state: active });
    }

    render() {
        var timer = "00:00"
        var clr_Btn = ""
        var elapsed = Math.round(this.state.elapsed / 100);
        var seconds = (elapsed / 10).toFixed(1); //"01:10:12:12"

        var showStopwatch = <span></span>;

        if(this.state.active_state === "RESUME")
            clr_Btn = <span style={{position:"relative",top:"0px", paddingLeft:70, color:"#fff", border:"0px solid red"}} onClick={this.handleStopCounter}>

                                {/*<img src={require('../images/utils/vert_white_line.png')}
                                     width="3" height="120"
                                     style={{float:"right", position:"relative", top:"-10px", left:"-10px" }}/> */ }
                            { /* <span style={{position:"relative", color:"red", fontSize:"50px", top:"-50px", left:"-40px" }}>
                                |
                            </span>*/ }
                            <span className="glyphicon glyphicon-remove-circle beginGlyphIcon"/>
                            STOP
                      </span>

        if(this.state.display)
            showStopwatch = <span className="beginBtnFooter">
                                    <span style={{display:"inline-block",width:"100%", border:"0px solid red", textAlign: "center"}}>
                                            <span onClick={this.handleCounter}>
                                                <span className="glyphicon glyphicon-time beginGlyphIcon"/>
                                                { this.state.active_state }
                                                <span style={{paddingRight:7}}/>
                                                <span style={{display:"inline-block", minWidth:"40px", textAlign:"center"}}>
                                                    { seconds }
                                                </span>
                                            </span>
                                            <span style={{paddingLeft: 20, float:"right"}}/>
                                            { clr_Btn }
                                     </span>
                                </span>

        return showStopwatch;
    }
}



// WEBPACK FOOTER //
// ./src/components/StopWatch.js